/** @format */

import { Component, Input, OnInit, Output, EventEmitter, ContentChild } from "@angular/core";
import { NsEmpWebExpData } from "../../../models/emp-web-exp.model";
import { BaseWidget } from "mis-crystal-design-system/widgets";
import { ListCardComponent } from "../list-card/list-card.component";

@Component({
  selector: "mis-employee-web-exp-widget-card",
  templateUrl: "./widget-card.component.html",
  styleUrls: ["./widget-card.component.scss"]
})
export class WidgetCardComponent implements OnInit {
  @Input() name: string;
  @Input() showLightName = true;
  @Input() actions: Array<{ name: string; id: number }> = [];
  @Input() widget: NsEmpWebExpData.IWidget;
  @Input() actionPosition: "top" | "bottom" = "top";
  @Output() action = new EventEmitter<number>(true);
  @ContentChild(ListCardComponent) listWidget: ListCardComponent;
  @Input() widgetControl: BaseWidget<unknown>;

  constructor() {}

  ngOnInit(): void {}

  cardAction(act: number): void {
    this.action.emit(act);
    this.listWidget?.cardAction(act, this.widget);
  }
}
